import { render, staticRenderFns } from "./CustomersOrderReport.vue?vue&type=template&id=abff87ee&"
import script from "./CustomersOrderReport.vue?vue&type=script&lang=js&"
export * from "./CustomersOrderReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports